import { render, staticRenderFns } from "./facturacion-menu.vue?vue&type=template&id=2cd74732&scoped=true"
import script from "./facturacion-menu.vue?vue&type=script&lang=js"
export * from "./facturacion-menu.vue?vue&type=script&lang=js"
import style0 from "./facturacion-menu.vue?vue&type=style&index=0&id=2cd74732&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cd74732",
  null
  
)

export default component.exports